export const DATE_INPUT_MAX = "9999-12-31";

const ISO_DATE_RE = /^\+?(\d+)-(\d{2})-(\d{2})$/;
const DMY_DATE_RE = /^(\d{1,2})-(\d{1,2})-(\d+)$/;

export const limitDateInputYear = (value?: string | null): string => {
  const raw = String(value ?? "");
  if (!raw) return "";

  const match = raw.match(ISO_DATE_RE);
  if (!match) return raw;

  const [, year, month, day] = match;
  if (year.length <= 4) {
    return raw.startsWith("+") ? `${year}-${month}-${day}` : raw;
  }

  return `${year.slice(0, 4)}-${month}-${day}`;
};

export const readLimitedDateInputValue = (
  input: HTMLInputElement,
): string => {
  const limitedValue = limitDateInputYear(input.value);
  if (input.value !== limitedValue) {
    input.value = limitedValue;
  }
  return limitedValue;
};

export const resolveDateInputMax = (max?: string | null): string => {
  const limitedMax = limitDateInputYear(max);
  if (!limitedMax) return DATE_INPUT_MAX;
  return limitedMax > DATE_INPUT_MAX ? DATE_INPUT_MAX : limitedMax;
};

export const dateYearHasFourDigits = (value: unknown): boolean => {
  if (value === undefined || value === null || String(value).trim() === "") {
    return true;
  }

  const raw = String(value).trim();
  const isoMatch = raw.match(ISO_DATE_RE);
  if (isoMatch) return isoMatch[1].length === 4;

  const dmyMatch = raw.match(DMY_DATE_RE);
  if (dmyMatch) return dmyMatch[3].length === 4;

  return true;
};
